









































































































































































































import TableDynamicFilter from "@/components/TableDynamicFilter.vue";
import PagedItems from "@/components/PagedItems.vue";
import FilterMenu from "@/components/Filter/FilterMenu.vue";
import { mapGetters } from "vuex";

export default {
  name: "TableDynamic",
  components: {
    TableDynamicFilter,
    PagedItems,
    FilterMenu
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      default: null
    },
    primaryKey: {
      type: String,
      default: null
    },
    secondaryKey: {
      type: String,
      default: null
    },
    sortBy: {
      type: String,
      default: null
    },
    stickyCol: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    filters: {
      default: null,
      type: Object
    },
    filterEnum: {
      type: Object,
      default: null
    },
    viewName: {
      type: String,
      default: null
    },
    showSearchbar: {
      type: Boolean,
      default: true
    },
    useFilter: Boolean //Sidemenu
  },
  data() {
    return {
      search: null,
      totalRows: this.items.length,
      itemrange: [0, this.$store.getters.getPerPage],
      totalItemCount: this.items.length,
      widths: [],
      xScroll: 0,
      shouldResize: false,
      // d for Data:
      dFilters: this.filters,
      dSortBy: this.sortBy,
      dSortDesc: this.sortDesc,
      scrollbarWidth: 0,
      hasScrollbarTop: false,
      showMobileMenu: false
    };
  },
  computed: {
    ...mapGetters(["filteredList"]),

    // Item manipulation step 1.
    filteredItems(): any[] {
      if (this.useFilter) {
        if (!this.dFilters) {
          return this.filteredList;
        }

        return this.filteredList.filter(item => {
          for (const filter in this.dFilters) {
            console.log("filter1");
            console.log(filter);
            if (!this.dFilters[filter][item[filter]]) {
              return false;
            }
          }

          return true;
        });
      } else {
        if (!this.dFilters) {
          return this.items;
        }

        return this.items.filter(item => {
          for (const filter in this.dFilters) {
            console.log("filter2");
            console.log(filter);
            console.log(item[filter]);
            if (!this.dFilters[filter][item[filter]]) {
              return false;
            }
          }

          return true;
        });
      }
    },
    // Item manipulation step 2.
    searchedItems(): any[] {
      if (!this.search) {
        return this.filteredItems;
      }

      return this.filteredItems.filter(item => {
        return Object.values(item).some(
          (value: string | number | boolean | object) => {
            if (
              value === null ||
              value === undefined ||
              typeof value === "object"
            ) {
              return false;
            }

            if (typeof value === "number") {
              value = value.toString();
            }

            if (typeof value === "boolean") {
              return false;
            }

            return value.toLowerCase().includes(this.search.toLowerCase());
          }
        );
      });
    },
    // Item manipulation step 3.
    sortedItems(): any[] {
      if (!this.dSortBy) {
        return this.searchedItems;
      }

      return this.searchedItems.slice().sort((a, b) => {
        const aElement = a[this.dSortBy];
        const bElement = b[this.dSortBy];

        if (aElement === null) {
          return 1;
        }

        if (bElement === null) {
          return -1;
        }

        if (aElement === bElement) {
          return 0;
        }

        if (!this.dSortDesc) {
          return aElement < bElement ? -1 : 1;
        }

        if (this.dSortDesc) {
          return aElement < bElement ? 1 : -1;
        }

        return 0;
      });
    },
    // Item manipulation step 4 (last step).
    pagedItems(): any[] {
      this.totalItemCount = this.sortedItems.length;
      return this.sortedItems.slice(this.itemrange[0], this.itemrange[1]);
    },
    // c for Computed:
    cFields() {
      if (this.items.isEmpty()) {
        return [];
      }

      if (!this.fields) {
        return Object.keys(this.items[0]).map(item => {
          return {
            key: item
          };
        });
      }

      return [...this.fields].sort((a, b) => {
        if (!a.order || !b.order) {
          return 0;
        }

        if (a.order < b.order) {
          return -1;
        }

        if (a.order > b.order) {
          return 1;
        }

        return 0;
      });
    }
  },
  watch: {
    fields() {
      this.shouldResize = true;
    },
    pagedItems() {
      this.shouldResize = true;
    }
  },
  created() {
    this.resize();
    this.resizeTopScrollbar();
  },
  updated() {
    if (this.shouldResize) {
      this.resize();
      this.resizeTopScrollbar();
      this.shouldResize = false;
    }
  },
  mounted() {
    this.$refs.body.addEventListener("scroll", this.scrollHeader);

    // Resize on img load fix:
    const img: any = document.querySelector("table img");
    if (img) {
      img.addEventListener("load", this.resize);
    }

    // Resize:
    window.addEventListener("resize", this.resize);
    this.resize();
    this.resizeTopScrollbar();
  },
  methods: {
    updateList(range) {
      this.itemrange = range;
    },

    getRowKey(item) {
      if (!this.secondaryKey) {
        return item[this.primaryKey];
      }

      if (!item[this.secondaryKey]) {
        return item[this.primaryKey];
      }

      return `${item[this.primaryKey]}-${item[this.secondaryKey]}`;
    },
    label(field) {
      return field.label === undefined ? field.key : field.label;
    },
    sort(key) {
      this.shouldResize = true;

      if (this.dSortBy !== key) {
        this.dSortBy = key;
        return;
      }

      this.dSortDesc = !this.dSortDesc;
    },
    row(item, key) {
      return {
        item,
        value: item[key]
      };
    },
    resizeTopScrollbar() {
      if (!this.$refs.table) {
        return;
      }

      this.scrollbarWidth = this.$refs.table.offsetWidth + "px";
      this.hasScrollbarTop =
        this.$refs.body.scrollWidth > this.$refs.body.clientWidth;
    },
    resize() {
      const newWidths = [];

      for (let i = 0; i < this.cFields.length; i++) {
        const headerRef = this.$refs[`th-${i}`];

        if (!headerRef) {
          continue;
        }

        if (!headerRef[0]) {
          continue;
        }

        newWidths[i] = headerRef[0].offsetWidth;
      }

      this.widths = newWidths;
    },
    scrollHeader() {
      const header = this.$refs.header;
      const body = this.$refs.body;
      header.scrollLeft = body.scrollLeft;
    },
    scrollBar(event) {
      if (this.$refs.scrollbar) {
        this.$refs.scrollbar.scrollLeft = event.target.scrollLeft;
      }
    },
    scrollTable(event) {
      if (this.$refs.body) {
        this.$refs.body.scrollLeft = event.target.scrollLeft;
      }
    }
  }
};
